const MICROSECOND = 1000000;
const FRAMES_PER_SECOND = 30;
const secondsToMicroseconds = (seconds) => seconds * MICROSECOND;
const MID_FRAME_VIDEO_OFFSET_MICROSECONDS = secondsToMicroseconds(0.5 / FRAMES_PER_SECOND);
/*
 *  Maps a timestamp in microseconds to a discrete timestep based on a given frequency (30fps).
 *  This is used to map a video timestamp to its corresponding timestep in the tracking world.
 */
const microsecondsToTimestep = (microseconds, frequency = FRAMES_PER_SECOND) => {
    const stepSize = MICROSECOND / frequency;
    return Math.floor(Math.floor((microseconds + 0.7) / stepSize) * stepSize);
};
const microsecondsToSeconds = (microseconds) => microseconds / 1e6;

export { FRAMES_PER_SECOND, MICROSECOND, MID_FRAME_VIDEO_OFFSET_MICROSECONDS, microsecondsToSeconds, microsecondsToTimestep, secondsToMicroseconds };
//# sourceMappingURL=time.js.map
